export const ACTIONS = {
  JOIN: "join",
  LEAVE: "leave",
  ADD_PEER: "add-peer",
  RELAY_ICE: "relay-ice",
  RELAY_SDP: "relay-sdp",
  ICE_CANDIDATE: "ice-candidate",
  SESSION_DESCRIPTION: "session-description",
  REMOVE_PEER: "remove-peer",
  MUTE: "mute",
  UN_MUTE: "un-mute",
};
